export class GalleryLightbox {
    constructor() {
        this.init();
    }
    init() {
        const thumbnails = document.querySelectorAll('.traffic-image');
        thumbnails.forEach(thumb => {
            thumb.addEventListener('click', e => {
                e.preventDefault();
                const bigSrc = this.getBigImageSrc(thumb);
                this.openLightboxWithZoom(thumb, bigSrc);
            });
            thumb.addEventListener('keydown', e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const bigSrc = this.getBigImageSrc(thumb);
                    this.openLightboxWithZoom(thumb, bigSrc);
                }
            });
        });
    }
    getBigImageSrc(thumb) {
        const dataBigSrc = thumb.getAttribute('data-big-src');
        if (dataBigSrc) {
            return dataBigSrc;
        }
        const srcSetCandidates = thumb.srcset
            .split(',')
            .map(candidate => candidate.trim().split(/\s+/)[0])
            .filter(Boolean);
        return srcSetCandidates[srcSetCandidates.length - 1] || thumb.currentSrc || thumb.src;
    }
    openLightboxWithZoom(thumb, src) {
        const rect = thumb.getBoundingClientRect();
        const overlay = document.createElement('div');
        overlay.className = 'gallery-lightbox-overlay';
        overlay.tabIndex = 0;
        const img = document.createElement('img');
        img.src = src;
        img.className = 'gallery-lightbox-image';
        img.style.position = 'fixed';
        img.style.top = '50%';
        img.style.left = '50%';
        const originX = rect.left + rect.width / 2;
        const originY = rect.top + rect.height / 2;
        img.style.transformOrigin = `${originX}px ${originY}px`;
        img.style.transform = 'translate(-50%, -50%) scale(0)';
        img.style.transition = 'transform 300ms ease-in-out';
        img.style.maxHeight = '90vh';
        img.style.cursor = 'default';
        img.style.zIndex = '1001';
        const closeBtn = document.createElement('button');
        closeBtn.innerHTML = '×';
        closeBtn.className = 'gallery-lightbox-close';
        const close = () => {
            img.style.transform = 'translate(-50%, -50%) scale(0)';
            overlay.classList.remove('visible');
            overlay.removeEventListener('keydown', onKeyDown);
            setTimeout(() => {
                overlay.remove();
            }, 300);
        };
        const onKeyDown = (e) => {
            if (e.key === 'Escape') {
                close();
            }
        };
        closeBtn.addEventListener('click', close);
        overlay.addEventListener('click', close);
        img.addEventListener('click', e => e.stopPropagation());
        overlay.addEventListener('keydown', onKeyDown);
        overlay.appendChild(img);
        overlay.appendChild(closeBtn);
        document.body.appendChild(overlay);
        overlay.focus();
        requestAnimationFrame(() => {
            overlay.classList.add('visible');
            img.style.transform = 'translate(-50%, -50%) scale(1)';
        });
    }
}
export function initGalleryLightbox() {
    new GalleryLightbox();
}
